<div style="text-align: center;">
  <a href="https://web.certicamara.com/servicios/firmas-digitales/certificados" style="cursor: pointer;" class="image">
    <img style="cursor: pointer; width: 100%;" src="./../../../../assets/header.jpg">
  </a>
</div>